//Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import { rem } from 'polished';

// Components
import Branding from '~/components/general/branding/index';
import Greeting from '../greeting';
import { INDEX_URL } from '~/data/constants/router-constants';

/**********
 ** Component: ErrorContainer
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const ErrorContainer = props => (
	<Wrapper id="error-message" className="cell hd-3 large-5 small-12">
		<Branding />
		<main id="error-message-main">
			<Greeting greeting={`${props.greeting}`} />
			<div id="error-message-content">
				<p className="email-form__body">{props.message}</p>
				<fieldset className="email-form__fields">
					<Link to={`${props.to}`} className="email-form__secondary">
						{`${props.label}`}
					</Link>
				</fieldset>
			</div>
		</main>
	</Wrapper>
);

// Styled Components
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(2rem);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	overflow-y: auto;

	background-color: #006aee;
	padding-top: ${props => props.theme.globalPadding};
	padding-right: ${props => props.theme.globalPadding};
	padding-bottom: ${props => props.theme.globalPadding};
	padding-left: ${props => props.theme.globalPadding};
	width: 100%;

	@media ${props => props.theme.breakpointMedium} {
		padding-top: ${rem('24px')};
		padding-right: ${rem('32px')};
		padding-bottom: ${rem('24px')};
		padding-left: ${rem('32px')};
	}

	@media ${props => props.theme.breakpointMedium} {
		padding-top: ${rem('24px')};
		padding-right: ${rem('32px')};
		padding-bottom: ${rem('24px')};
		padding-left: ${rem('32px')};
	}

	@media ${props => props.theme.breakpointLarge} {
		padding-right: ${rem('32px')};
		padding-left: ${rem('64px')};
	}

	@media ${props => props.theme.breakpointHd} {
		padding-right: ${rem('64px')};
		padding-left: ${rem('128px')};
	}

	#error-message-main {
		display: flex;
		align-self: flex-start;
		flex-direction: column;
		width: 100%;
	}

	.branding__link {
		width: ${rem('226px')};
		height: ${rem('48px')};
		display: flex;
		align-self: flex-start;
		margin-bottom: ${rem('32px')};

		@media ${props => props.theme.breakpointMedium} {
			margin-bottom: ${rem('48px')};
		}

		@media ${props => props.theme.breakpointLarge} {
			margin-bottom: ${rem('64px')};
		}
	}

	#error-message,
	#error-message-main,
	#error-message-content {
		opacity: 0;
		animation-name: ${fadeInUp};
		animation-timing-function: ${props => props.theme.easeOutCirc};
		animation-duration: 1000ms;
		animation-fill-mode: forwards;
	}

	#greeting {
		animation-delay: 125ms;
	}

	#error-message-main {
		animation-delay: 250ms;
	}

	#error-message-content {
		margin-top: ${rem('16px')};
		margin-bottom: ${rem('16px')};
		animation-delay: 750ms;

		.email-form__body {
			margin-bottom: ${rem('16px')};
		}

		.email-form__secondary {
			text-align: center;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}
	}
`;

ErrorContainer.defaultProps = {
	greeting: 'Oops...',
	message: `Default message`,
	to: INDEX_URL,
	label: 'Try Again',
};

ErrorContainer.propTypes = {
	greeting: PropTypes.string,
	message: PropTypes.string,
	to: PropTypes.string,
	label: PropTypes.string,
};

export default ErrorContainer;



// WEBPACK FOOTER //
// ./src/pages/login/error-page/error-container.jsx